import { Button, Modal, Typography } from 'src/modules/core/components'
import type { PolicyConfirmModalProps } from './policy-confirm-modal.interface'
import classes from './policy-confirm-modal.module.scss'

export function PolicyConfirmModal({
  title,
  children,
  cancelLabel,
  confirmLabel,
  destructive = false,
  isLoading = false,
  onCancel,
  onConfirm,
  testId,
}: PolicyConfirmModalProps) {
  return (
    <Modal
      onClose={isLoading ? undefined : onCancel}
      title={
        <Typography variant="h3" className={classes.title}>
          {title}
        </Typography>
      }
      isCentered
      className={classes.modal}
      contentClassName={classes.content}
    >
      <div role="dialog" aria-label={title} data-testid={testId}>
        <div className={classes.body}>{children}</div>
        <div className={classes.buttons}>
          <Button variant="withBorder" onClick={onCancel} disabled={isLoading}>
            {cancelLabel}
          </Button>
          <Button
            variant={destructive ? 'danger' : 'primary'}
            onClick={onConfirm}
            disabled={isLoading}
            isLoading={isLoading}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
